import Vue from 'vue'
import App from './App'
import router from './router'
import api from './services/Webservice'
import VeeValidate from 'vee-validate';
import shareService from './services/ShareService'
import 'vuejs-noty/dist/vuejs-noty.css'
import VueNoty from 'vuejs-noty'
import VueI18n from 'vue-i18n'
import moment from 'moment'
import i18n from './i18n'
import VueNumeric from 'vue-numeric'
import VueTour from 'vue-tour'

require('vue-tour/dist/vue-tour.css')

Vue.use(VueTour)
Vue.config.productionTip = false
Vue.use(VueNoty, {
  timeout: 1500
})
new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  i18n,
  template: '<App/>'
})


Vue.$api = api
Vue.$shareService = shareService

Object.defineProperty(Vue.prototype, '$api', {
  get() {
    return api
  }
});


Object.defineProperty(Vue.prototype, '$analytics', {
  get() {
    return Analytics
  }
});


Object.defineProperty(Vue.prototype, '$shareService', {
  get() {
    return shareService
  }
})

Vue.use(VeeValidate, {
  classes: true
})
Vue.use(require('vue-moment'))
Vue.use(VueI18n)
Vue.use(VueNumeric)

Vue.filter('titleCase', function (value) {
  if (!value) {
    return ''
  } else {
    var str = ''
    var arr = value.split('_')
    for (var i = 0; i < arr.length; i++) {
      if (i == 0) {
        str = arr[i].charAt(0).toUpperCase() + arr[i].substring(1).toLowerCase();
      } else {
        str = str + ' ' + arr[i].charAt(0).toUpperCase() + arr[i].substring(1).toLowerCase();
      }
    }
    return str
  }
})


Vue.filter('companyName', function (value) {
  if (!value) {
    return ''
  } else {
    var str = ''
    for (var i = 0; i < value.length; i++) {
      if (i == 0) {
        str = value[i].company_name
      } else if (i == 1) {
        str = str + ', ' + value[i].company_name;
      } else {
        str = str + '...';
        return str;
      }
    }
    return str
  }
})

Vue.filter('promotionName', function (value) {
  if (!value) {
    return ''
  } else {
    var str = ''
    for (var i = 0; i < value.length; i++) {
      if (i == 0) {
        str = value[i].title
      } else {
        str = str + ', ' + value[i].title;
      }
    }
    return str
  }
})

Vue.filter('failureReason', function (value) {
  if (!value) {
    return ''
  } else {
    var str = ''
    for (var i = 0; i < value.length; i++) {
      if (i == 0) {
        str = value[i]
      } else {
        str = str + ', ' + value[i];
      }
    }
    return str
  }
})


Vue.filter('rolename', function (value) {
  if (!value) {
    return ''
  } else {
    var str = ''
    for (var i = 0; i < value.length; i++) {
      if (i == 0) {
        str = value[i].role_name
      } else {
        str += ', ' + value[i].role_name;
      }
    }
    return str
  }
})

Vue.filter('dateFormat', function (value) {
  if (!value) {
    return ''
  } else {
    return moment(new Date()).format(value);
  }
})

Vue.filter('validFrom', function (value) {
  if (!value) {
    return ''
  } else {
    var str = ''
    for (var i = 0; i < value.length; i++) {
      if (i == 0) {
        str = value[i].valid_from
      } else {
        str = value[i].valid_from;
      }
    }
    return str
  }
})

Vue.filter('titleCase', function (value) {
  if (!value) {
    return ''
  } else {
    var str = ''
    var arr = value.split('_')
    for (var i = 0; i < arr.length; i++) {
      if (i == 0) {
        str = arr[i].charAt(0).toUpperCase() + arr[i].substring(1).toLowerCase();
      } else {
        str += ' ' + arr[i].charAt(0).toUpperCase() + arr[i].substring(1).toLowerCase();
      }
    }
    return str
  }
})

Vue.filter('validTo', function (value) {
  if (!value) {
    return ''
  } else {
    var str = ''
    for (var i = 0; i < value.length; i++) {
      if (i == 0) {
        str = value[i].valid_to
      } else {
        str = value[i].valid_to;
      }
    }
    return str
  }
})
Vue.filter('minamt', function (value) {
  if (!value) {
    return ''
  } else {
    var str = ''
    for (var i = 0; i < value.length; i++) {
      if (i == 0) {
        str = value[i].min_amount
      } else {
        str = value[i].min_amount;
      }
    }
    return str
  }
})
Vue.filter('maxamt', function (value) {
  if (!value) {
    return ''
  } else {
    var str = ''
    for (var i = 0; i < value.length; i++) {
      if (i == 0) {
        str = value[i].max_amount
      } else {
        str = value[i].max_amount;
      }
    }
    return str
  }
})
Vue.filter('fee', function (value) {
  if (!value) {
    return ''
  } else {
    var str = ''
    for (var i = 0; i < value.length; i++) {
      if (i == 0) {
        str = value[i].fee
      } else {
        str = value[i].fee;
      }
    }
    return str
  }
})
Vue.filter('documentId', function (value) {
  if (!value) {
    return ''
  } else {
    var str = ''
    for (var i = 0; i < value.length; i++) {
      if (i == 0) {
        str = value[i].document_id
      } else {
        str = value[i].document_id;
      }
    }
    return str
  }
})

Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(String(value)).format('DD-MM-YYYY')
  }
});



// WEBPACK FOOTER //
// ./src/main.js